import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class ManualOrder {
  /* 物流登记记录列表 */
  static getManualOrderRecordsList(option) {
    let url = `/oa/api/logistics/manual/order/page?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 物流登记记录导出 */
  static getExportManualOrder(data) {
    let url = `/oa/api/download/logistics/manual/order?`
    url += handleGetRequestParams(data)
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
  /* 作废物流登记记录 */
  static postNullify(id) {
    const url = `/oa/api/logistics/manual/order/remove/${id}`
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /** 
   * @description 运单号是否存在
  */
  static getExpressNoIsExist(expressNo) {
    const url = `/oa/api/logistics/manual/order/expressNo/is/exist?expressNo=${expressNo}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 物流登记 */
  static postUploadManualOrder(data) {
    const url = `/oa/api/logistics/manual/order/save`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default ManualOrder;